export const getLabelRoleName = (role: string): string =>
  `${role[0].toUpperCase()}${role.slice(1)}`.split('_').join(' ');
